"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobType = void 0;
var JobType;
(function (JobType) {
    JobType["BULK_STUDENT_PROFILE_PHOTO_UPLOAD"] = "BULK_STUDENT_PROFILE_PHOTO_UPLOAD";
    JobType["BULK_STUDENT_EVENT_CSV_UPLOAD"] = "BULK_STUDENT_EVENT_CSV_UPLOAD";
    JobType["DOWNLOADABLE_REPORTS"] = "DOWNLOADABLE_REPORTS";
    JobType["BEHAVIOR_CODE_ENTRY_UPLOAD"] = "BEHAVIOR_CODE_ENTRY_UPLOAD";
    JobType["ACTIVATE_GUARDIANS"] = "ACTIVATE_GUARDIANS";
    JobType["CUSTOM_ROSTER_CSV_IMPORT"] = "CUSTOM_ROSTER_CSV_IMPORT";
    JobType["CLOSE_HERO_EVENTS"] = "CLOSE_HERO_EVENTS";
})(JobType || (exports.JobType = JobType = {}));
